module.exports = __webpack_public_path__ + "static/MFS_Logo_Greyscale_RGB-aca478264bda096904433a9c4f6c749e.png";